const recommendRouter = () => {
    return [{
        path: 'recommend-v',
        name: 'recommend-v',
        component: () => import(/* webpackChunkName: "recommend" */ '../../modules/recommend/index.vue')
    }];
};
export default recommendRouter;
